import { safeParse } from 'shouldve-been-js';
import OrderValidationResultMessageLevel from '../Enums/OrderValidatioResultMessageLevel';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleInfo, faHand, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

class OrderValidationResultMessage {

    private _level: OrderValidationResultMessageLevel;
    private _infoMessage: string;

    public constructor(level: OrderValidationResultMessageLevel, infoMessage: string) {

        this._level = level;
        this._infoMessage = infoMessage;
    }

    public get level(): OrderValidationResultMessageLevel {
        return this._level;
    }

    public set level(value: OrderValidationResultMessageLevel) {
        this._level = value;
    }

    public get infoMessage(): string {
        return this._infoMessage;
    }

    public set infoMessage(value: string) {
        this._infoMessage = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): OrderValidationResultMessage {

        const infoMessage: string = safeParse<string>(json?.InfoMessage, '');
        const levelString: string = safeParse<string>(json?.Level, '');

        let level: OrderValidationResultMessageLevel = OrderValidationResultMessageLevel.NONE;

        if (levelString === OrderValidationResultMessageLevel.INFO) {
            level = OrderValidationResultMessageLevel.INFO;
        } else if (levelString === OrderValidationResultMessageLevel.WARNING) {
            level = OrderValidationResultMessageLevel.WARNING;
        }else if (levelString === OrderValidationResultMessageLevel.STOP) {
            level = OrderValidationResultMessageLevel.STOP;
        }

        return new OrderValidationResultMessage(level, infoMessage);
    }

    public getIcon(): IconProp | null {

        if (this.level === OrderValidationResultMessageLevel.INFO) {
            return faCircleInfo;
        } else if (this.level === OrderValidationResultMessageLevel.WARNING) {
            return faTriangleExclamation;
        } else if (this.level === OrderValidationResultMessageLevel.STOP) {
            return faHand;
        } else {
            return null;
        }
    }

    public getIconColor(): string {

        if (this.level === OrderValidationResultMessageLevel.INFO) {
            return '#007A8C';
        } else if (this.level === OrderValidationResultMessageLevel.WARNING) {
            return '#FFCC00';
        } else if (this.level === OrderValidationResultMessageLevel.STOP) {
            return '#D1232C';
        } else {
            return '#CCCCCC'; //not really in use, as icon won't be shown in this case
        }
    }
}

export default OrderValidationResultMessage;